import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PharosApiResponse, TenantDefault, UpdateTenantDefault } from '@klareospace/pharos-lib-types';

// ─── API Factory ──────────────────────────────────────────────────────────────

export function createTenantDefaultApi(client: ApiClient): {
  fetchTenantDefaults: () => Promise<TenantDefault>;
  updateTenantDefaults: (data: UpdateTenantDefault) => Promise<TenantDefault>;
} {
  return {
    fetchTenantDefaults: async (): Promise<TenantDefault> => {
      const response = await client.execute<PharosApiResponse<TenantDefault>>(() =>
        client.instance.get('/tenant-defaults'),
      );
      if (!response.data) {
        throw new Error('Unexpected empty response from API');
      }
      return response.data;
    },

    updateTenantDefaults: async (data: UpdateTenantDefault): Promise<TenantDefault> => {
      const response = await client.execute<PharosApiResponse<TenantDefault>>(() =>
        client.instance.patch('/tenant-defaults', data),
      );
      if (!response.data) {
        throw new Error('Unexpected empty response from API');
      }
      return response.data;
    },
  };
}
